import styled from 'styled-components';
import { palette } from 'styled-tools';

import MarketingOptIn from '@/components/authForm/MarketingOptIn';

export const Wrapper = styled.div`
	color: ${palette('gray7')};
	text-align: center;
`;

export const StyledMarketingOptIn = styled(MarketingOptIn)`
	text-align: left;
`;

export const HeadingWrapper = styled.div`
	display: grid;
	grid-row-gap: 0.5rem;
	margin-bottom: 2rem;
`;

export const FootingWrapper = styled.div`
	display: grid;
	grid-row-gap: 0.5rem;
	margin-top: 2rem;
`;

export const SocialSignupWrapper = styled.ul`
	list-style-type: none;
	padding: 0;
`;
